import { useCallback } from "react";

import { MapModes } from "constant";
import MapMarkerContextMenu from "scenes/MapPage/components/MapMarkerContextMenu/MapMarkerContextMenu";

// interface useMarkerEventHandlersInterface {}

export const useMarkerEventHandlers = ({
  marker,
  draggableId,
  mapMode,
  onAcceptDragging,
  onCancelDragging,
  onMarkerClick,
  onDragEnd,
  openContextMenu,
  onMoveMarker
}) => {
  const onDraggableMarkerClick = useCallback(
    (e) => {
      const target = e.originalEvent.target as HTMLElement;
      const confirmButton = target.closest("#marker-check");
      const cancelButton = target.closest("#marker-cancel");

      if (confirmButton) {
        onAcceptDragging();
      } else if (cancelButton) {
        onCancelDragging();
      }
    },
    [onAcceptDragging, onCancelDragging]
  );

  const onContextMenu = (e) => {
    const containerPoint = e.containerPoint;

    if (mapMode === MapModes.DEFAULT)
      setTimeout(() => {
        //A timeout is needed to show the current data of the polygon we click on. Due to the click event handler that is running in parallel in the MapEventHandler component, we cannot do this as usual.
        openContextMenu({
          position: {
            x: containerPoint.x,
            y: containerPoint.y
          },
          customMenu: (
            <MapMarkerContextMenu
              marker={marker}
              onMove={onMoveMarker(marker)}
            />
          )
        });
      }, 0);
  };

  if (draggableId === marker.id) {
    return {
      click: onDraggableMarkerClick,
      dragend: onDragEnd
    };
  }

  return {
    click: onMarkerClick(marker),
    contextmenu: onContextMenu
  };
};
